import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from '../MenuItem';

const Menu = ({ className, items, onSelect }) => {
  const handleSelect = (e, clickHandler) => {
    e.preventDefault();
    e.stopPropagation();

    if (onSelect) onSelect();
    if (clickHandler) clickHandler();
  };

  return (
    <div className={className}>
      {items.map(
        (
          {
            active,
            icon,
            iconSize,
            onClick,
            text,
            danger,
            borderTop,
            id,
            submenu,
          },
          i,
        ) => (
          <MenuItem
            id={id}
            key={id || i}
            submenu={submenu}
            active={active}
            icon={icon}
            iconSize={iconSize}
            text={text}
            danger={danger}
            borderTop={borderTop}
            onClick={e => handleSelect(e, onClick)}
          />
        ),
      )}
    </div>
  );
};

Menu.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      icon: PropTypes.string,
      onClick: PropTypes.func,
      text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    }),
  ),
  onSelect: PropTypes.func,
};

export default Menu;



// WEBPACK FOOTER //
// ./src/components/common/IconMenu/Menu/index.jsx